import { Component } from '@angular/core';

interface NoHassle {
  icon: string;
  title: string;
  description: string;
}

@Component({
  selector: 'app-benefits',
  templateUrl: './benefits.component.html',
  styleUrls: ['./benefits.component.scss',],
})
export class BenefitsComponent {

  constructor() { }

  noHassles: NoHassle[] = [
    {
      icon: 'assets/images/landing-page/downpayment.svg',
      title: 'Zero Down-Payment',
      description: 'We help you save heavy one-time money commitments on your car purchase.',
    },
    {
      icon: 'assets/images/landing-page/whitenumberplate.svg',
      title: 'White Number Plate',
      description: 'Our cars are delivered to you with a white number car plate.',
    },
    {
      icon: 'assets/images/landing-page/service.svg',
      title: 'Service & Maintenance',
      description: 'We really love our cars. All regular wear and tear expenses are on us.',
    },
    {
      icon: 'assets/images/landing-page/RSA.svg',
      title: '24x7 RSA',
      description: 'We are available 24x7 around the clock to help you whenever you need us.',
    },
  ];


  contentList = [



  ];


}
